export const PAGE_SEO = {
  home: {
    title: 'Q-Gold Resources | Quartz Mountain & Mine Centre',
    description:
      'Q-Gold Resources is a Canadian gold company advancing Quartz Mountain in Oregon and Mine Centre in Ontario. News, technical reports, and investor materials.',
    path: '/',
  },
  news: {
    title: 'News & Press Releases | Q-Gold Resources',
    description:
      'Official news releases and corporate updates from Q-Gold Resources on Quartz Mountain, Mine Centre, financings, and project progress.',
    path: '/news',
  },
  company: {
    title: 'Company | Q-Gold Resources',
    description:
      'Learn about Q-Gold Resources, its leadership, and the team advancing Quartz Mountain and Mine Centre.',
    path: '/company',
  },
  investors: {
    title: 'Investors | Q-Gold Resources',
    description:
      'Investor materials for Q-Gold Resources, including share structure, presentations, filings, and why Quartz Mountain matters.',
    path: '/investors',
  },
  contact: {
    title: 'Contact | Q-Gold Resources',
    description:
      'Contact Q-Gold Resources for investor, media, or general inquiries at info@qgoldresources.com.',
    path: '/contact',
  },
  mediaCentre: {
    title: 'Media Centre | Q-Gold Resources',
    description:
      'Photos and visual updates from Q-Gold project work, site visits, presentations, and corporate events.',
    path: '/media-centre',
  },
  mineCentre: {
    title: 'Mine Centre Project | Q-Gold Resources',
    description:
      'Overview of the Q-Gold Mine Centre gold-silver project in Ontario, including geology, drilling, and project location.',
    path: '/project/mine-centre',
  },
  quartzMountain: {
    title: 'Quartz Mountain Project | Q-Gold Resources',
    description:
      'Overview of the Quartz Mountain gold project in Oregon, including the 2026 PEA, resource, and development outlook.',
    path: '/project/quartz-mountain',
  },
  legal: {
    title: 'Legal Notice | Q-Gold Resources',
    description:
      'Legal notice, terms of use, and disclaimer for the Q-Gold Resources website.',
    path: '/legal-notice',
  },
  comingSoon: {
    title: 'Coming Soon | Q-Gold Resources',
    description: 'This Q-Gold Resources page is not available yet.',
    path: '/coming-soon',
    noindex: true,
  },
  notFound: {
    title: 'Page Not Found | Q-Gold Resources',
    description: 'This page is not available on the Q-Gold Resources website.',
    noindex: true,
  },
};
